var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "language-picker" },
    [
      _c(
        "a-popover",
        {
          attrs: {
            placement: "bottomLeft",
            overlayClassName: "language-picker-popover",
            visible: _vm.visible,
            trigger: "click",
          },
          scopedSlots: _vm._u([
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { ref: "pickerContent", staticClass: "picker-content" },
                    [
                      _c("div", { staticClass: "picker-header" }, [
                        _c("span", [_vm._v("DİL SEÇİN")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "search-wrapper" },
                        [
                          _c("a-input-search", {
                            attrs: {
                              placeholder: "Search Item",
                              size: "large",
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "languages-list" },
                        _vm._l(_vm.filteredLanguages, function (lang) {
                          return _c(
                            "div",
                            {
                              key: lang.id,
                              staticClass: "language-item",
                              class: { selected: lang.id === _vm.value },
                              on: {
                                click: function ($event) {
                                  return _vm.selectLanguage(lang.id)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "language-flag-wrapper" },
                                [
                                  lang.countryCode
                                    ? _c("vue-country-flag", {
                                        staticClass: "language-flag",
                                        attrs: {
                                          country: lang.countryCode,
                                          size: "normal",
                                        },
                                      })
                                    : _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons language-icon",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(lang.icon || "language")
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "language-info" }, [
                                _c("div", { staticClass: "language-name" }, [
                                  _vm._v(_vm._s(lang.name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "language-description" },
                                  [_vm._v(_vm._s(lang.description))]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "language-trigger",
              on: { click: _vm.togglePopover },
            },
            [
              _c("div", { staticClass: "trigger-content" }, [
                _c(
                  "div",
                  { staticClass: "trigger-flag-wrapper" },
                  [
                    _vm.selectedLanguage && _vm.selectedLanguage.countryCode
                      ? _c("vue-country-flag", {
                          staticClass: "trigger-flag",
                          attrs: {
                            country: _vm.selectedLanguage.countryCode,
                            size: "normal",
                          },
                        })
                      : _c(
                          "i",
                          { staticClass: "material-icons trigger-icon" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$_.get(
                                  _vm.selectedLanguage,
                                  "icon",
                                  _vm.icon
                                )
                              )
                            ),
                          ]
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "trigger-label" }, [
                  _vm._v(
                    _vm._s(_vm.$_.get(_vm.selectedLanguage, "name", _vm.title))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "material-icons trigger-arrow" }, [
                _vm._v(
                  _vm._s(_vm.visible ? "arrow_drop_up" : "arrow_drop_down")
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }